module.exports = __webpack_public_path__ + "static/media/react-builds-cat.45f7f4d2.png";